<template>
  <div class="photovoltaicDevOps mainPageBg">
    <DevOpsPublicCom :system="'光伏系统'" />
  </div>
</template>

<script>
import DevOpsPublicCom from "@/components/DevOps/DevOpsPublicCom.vue";
export default {
  components: {
    DevOpsPublicCom,
  },
};
</script>

<style scoped lang="scss"></style>
